/* ══════════════════════════════════════════════════════════════════
   口碑墙的引用轮播。

   **换的是文字，不是卡片。** 整张卡飞进飞出会把旁边的图也带得晃；
   这里只让引号里那段字淡出淡入，卡的高度由最长的一条撑住，不跳。

   悬停即停、进度条可点、`prefers-reduced-motion` 不自动换（条直接填满）。
   视频走 component-blocks.js 那一份点击加载，这里不重复写。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 头像两种形态：有图是 <img>，没图是印首字母的 <span>（Liquid 那边同一套）。
     轮播到形态不同的一条时换元素 —— 给 span 设 src 没用，给 img 塞字也没用。 */
  function swapAvatar(av, q) {
    var wantImg = !!q.avatar;
    var isImg = av.tagName === 'IMG';
    if (wantImg !== isImg) {
      var next = document.createElement(wantImg ? 'img' : 'span');
      next.className = wantImg ? 'eb-tw__av' : 'eb-tw__av eb-tw__av--ini';
      next.setAttribute('data-tw-avatar', '');
      if (wantImg) {
        next.alt = '';
        next.width = 38;
        next.height = 38;
      } else {
        next.setAttribute('aria-hidden', 'true');
      }
      av.replaceWith(next);
      av = next;
    }
    if (wantImg) av.src = q.avatar;
    else av.textContent = q.initials || '';
    return av;
  }

  function init(root) {
    var box = root.querySelector('[data-tw-quotes]');
    if (!box) return;
    var items = JSON.parse(box.getAttribute('data-tw-quotes') || '[]');
    if (items.length < 2) return;

    var qt = root.querySelector('[data-tw-text]');
    var nm = root.querySelector('[data-tw-name]');
    var hd = root.querySelector('[data-tw-meta]');
    var av = root.querySelector('[data-tw-avatar]');
    var bars = Array.prototype.slice.call(root.querySelectorAll('.eb-tw__prog i'));
    var interval = parseInt(root.dataset.interval || '5000', 10);
    var i = 0;
    var timer = null;

    function paint(n) {
      var q = items[n];
      qt.classList.add('is-out');
      setTimeout(function () {
        qt.textContent = q.text || '';
        qt.hidden = !q.text;
        /* 空字段藏起来，不留一行空高度；下一条有字再亮出来 */
        if (nm) { nm.textContent = q.name || ''; nm.hidden = !q.name; }
        if (hd) { hd.textContent = q.meta || ''; hd.hidden = !q.meta; }
        if (av) av = swapAvatar(av, q);
        qt.classList.remove('is-out');
      }, 220);

      bars.forEach(function (b) { b.classList.remove('is-on'); });
      void root.offsetWidth;
      if (bars[n]) bars[n].classList.add('is-on');
    }

    function next(n) {
      i = (n + items.length) % items.length;
      paint(i);
      run();
    }
    function run() {
      clearTimeout(timer);
      if (REDUCED.matches || root.classList.contains('is-paused')) return;
      timer = setTimeout(function () { next(i + 1); }, interval);
    }

    root.addEventListener('click', function (e) {
      var bar = e.target.closest('.eb-tw__prog i');
      if (bar) next(bars.indexOf(bar));
    });
    root.addEventListener('mouseenter', function () { clearTimeout(timer); });
    root.addEventListener('mouseleave', run);
    root.addEventListener('focusin', function () { clearTimeout(timer); });
    root.addEventListener('focusout', run);

    if (bars[0]) bars[0].classList.add('is-on');
    run();
  }

  document.querySelectorAll('[data-testimonial]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-testimonial]').forEach(init);
  });
})();
